exports.content_warning = function ()
{
    $("#content_warning").modal(
        {
            fadeDuration: 250,
        }
    );
}

